import React, { useCallback, useState } from 'react';
import { useViewActions } from '@mm/state/actions/viewActions';
import { SlideoutMenu as Menu } from '../../components/SlideoutMenu';
import { SlideoutAttributes } from './SildeoutAttributes';
import { SlideoutTags } from './SildeoutTags';
import { useDetectOutsideClicks } from '../../../../../common/hooks/use-detect-outside-clicks';

const ATTRIBUTES_TAB = 'Attributes';
const TAGS_TAB = 'Tags';
const OTN_TAGS_TAB = '1-Time Notification Tags';

const tabNamings: { [key: string]: string } = {
  [OTN_TAGS_TAB]: 'Tags',
};

export const SlideoutMenuAttributessAndTags = () => {
  const [searchQuery, setSearchQeury] = useState('');
  const [activeTab, setActiveTab] = useState(ATTRIBUTES_TAB);
  const [showForm, setShowForm] = useState(false);
  const tabNaming = tabNamings[activeTab] || activeTab;
  const { hideSlideoutMenu } = useViewActions();

  const [wrapperRef, setWrapperRef] = useState<HTMLElement | null>(null);

  useDetectOutsideClicks(() => {
    hideSlideoutMenu();
  }, wrapperRef);

  const setRef = (ref: HTMLElement) => {
    setWrapperRef(ref);
  };

  const onSearchChange = (e: string) => setSearchQeury(e);
  const onActiveTabChange = useCallback((e: string) => {
    setActiveTab(e);
    setShowForm(false);
  }, []);
  const onShowFormToggle = useCallback(() => {
    setShowForm(!showForm);
  }, [showForm]);

  return (
    <Menu setRef={setRef}>
      <Menu.Header className="">
        <Menu.Tabs defaultActiveKey={activeTab} onChange={onActiveTabChange}>
          <Menu.Tabs.Item label={ATTRIBUTES_TAB} icon="attributes" />
          <Menu.Tabs.Item label={TAGS_TAB} icon="fa-tags" />
          <Menu.Tabs.Item label={OTN_TAGS_TAB} icon="fa-tags" />
        </Menu.Tabs>
      </Menu.Header>
      <Menu.Search
        placeholder={`Search ${tabNaming.toLowerCase().replace('s', '')}`}
        value={searchQuery}
        onChange={onSearchChange}
        rigthContent={
          <span tabIndex={0} onClick={onShowFormToggle}>
            <i className="plus" /> add{' '}
            {tabNaming.substr(0, tabNaming.length - 1).toLowerCase()}
          </span>
        }
      />
      {activeTab === ATTRIBUTES_TAB && (
        <SlideoutAttributes showAddForm={showForm} searchQuery={searchQuery} />
      )}
      {activeTab === TAGS_TAB && (
        <SlideoutTags
          showAddForm={showForm}
          searchQuery={searchQuery}
          kind="regular"
        />
      )}
      {activeTab === OTN_TAGS_TAB && (
        <SlideoutTags
          showAddForm={showForm}
          searchQuery={searchQuery}
          kind="otn"
        />
      )}
    </Menu>
  );
};
